<template>
  <!--
          作者：kmd
          时间：2021年9月4日 02点02分
          描述：用户结构
      -->
  <el-dialog width="600px" title="上级用户" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="dialog-box">

      <div class="parent-box">
        <div class="p-20-0">
          <el-radio-group v-model="reverse">
            <el-radio :label="true">倒序</el-radio>
            <el-radio :label="false">正序</el-radio>
          </el-radio-group>
        </div>
        <div class="p-20-0">
          <el-timeline :reverse="reverse">
            <el-timeline-item
              v-for="(item, index) in parentList"
              :key="index"
              :color="Number(item.user_id) === Number(initial_user_id) ? '#0bbd87' : ''"
              :timestamp="item.timestamp">
              <div class="custom-tree-node">
                <div class="avatar-image">
                  <el-avatar size="medium" icon="el-icon-user-solid" :src="item.avatarUrl"></el-avatar>
                </div>
                <div class="text-box">
                  <span class="lh30">[用户ID: {{ item.user_id }}]</span>
                  <span v-if="item.nickName"> 昵称: {{ item.nickName }}</span>
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

    </div>

    <div class="parent-bottom">
      <el-button type="primary" @click="dialogFormVisible">关闭</el-button>
      <el-button type="primary" @click="loadMore">查找更多</el-button>
    </div>
  </el-dialog>
</template>

<script>
import UserApi from '@/api/user.js'
export default {
  data() {
    return {
      reverse: true,
      /*横向表单数据模型*/
      formInline: {
        search:'',
        grade_id: '',
        reg_date: '',
        page: 1,
        list_rows: 10,
      },
      totalDataNumber: 0,
      gradeList: null,
      filterText: '',
      data: null,
      defaultProps: {
        children: 'children',
        label: 'label',
        isLeaf: 'leaf'
      },
      dialogVisible:false,
    }
  },
  props: ['parentList','open', 'initial_user_id'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    }
  },
  created() {

  },
  methods: {
    loadMore(){
      let self = this;
      let user_id = this.parentList[this.parentList.length-1].user_id;
      UserApi.getSuperior({ user_id })
        .then(res => {
          if(res.data.list){
            for(let i = 1; i < res.data.list.length; i++){
              self.parentList.push(res.data.list[i]);
            }
          }
        }).catch(error => {});
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.nickName.indexOf(value) !== -1;
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.el-dialog-div {
  height: 60vh;
  overflow: auto;
}
.parent-bottom{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.parent-box{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

}
.parnet-list{
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.custom-tree-node {
  display: flex;
  vertical-align: center;
  .avatar-image {
    display: inline-block;
    border-radius: 30px;
    overflow: hidden;
  }
  .text-box {
    margin-left: 8px;
    display: inline-block;
    line-height: 40px;
  }
}
.dialog-box {
  width: 100%;
  height: 550px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/user/userstructure/dialog/showParent.vue